export enum QuestionType {
    Selection = 'selection',
    Score = 'score',
    FreeText = 'freeText',
    ContactPerson = 'contactPerson',
    Text = 'text',
    Address = 'address',
}
